// Hulk Cart Price Fix v5 — точные селекторы Kalles
(function() {
  'use strict';

  function patchHulkCartSelector($) {
    if (!$ || !$.fn || !$.fn.init || $.fn.init._hulkCartSelectorGuard) return;

    var OriginalInit = $.fn.init;
    var GuardedInit = function(selector, context, root) {
      if (typeof selector === 'string' && selector.indexOf('..t4s-cart_price') === 0) {
        selector = selector.replace(/^\.+/, '.');
      }
      return new OriginalInit(selector, context, root);
    };

    GuardedInit.prototype = OriginalInit.prototype;
    GuardedInit._hulkCartSelectorGuard = true;
    $.fn.init = GuardedInit;
  }

  var selectorGuardAttempts = 0;
  var selectorGuardTimer = setInterval(function() {
    patchHulkCartSelector(window.hulkapps_jQuery);
    patchHulkCartSelector(window.jQuery_T4NT);
    patchHulkCartSelector(window.jQuery);
    selectorGuardAttempts += 1;
    if (selectorGuardAttempts > 40) clearInterval(selectorGuardTimer);
  }, 100);
  
  function formatMoney(cents) {
    if (window.T4SThemeSP && window.T4SThemeSP.Currency && typeof window.T4SThemeSP.Currency.formatMoney === 'function') {
      return window.T4SThemeSP.Currency.formatMoney(cents);
    }

    var dollars = (cents / 100).toFixed(2);
    var parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }
  
  function extractPriceFromText(text) {
    var total = 0;
    var matcher = /\[\s*\$?([\d,]+(?:\.\d{2})?)\s*\]/g;
    var match;
    while ((match = matcher.exec(text)) !== null) {
      total += parseFloat(match[1].replace(/,/g, '')) * 100;
    }
    return total;
  }
  
  var isUpdating = false;
  var debounceTimer = null;
  var pendingUpdate = false;
  
  function updateCartPrices() {
    if (isUpdating) {
      pendingUpdate = true;
      return;
    }
    isUpdating = true;
    
    var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var grandTotal = 0;
        updateCartCount(cart);
        
        cart.items.forEach(function(item) {
          var basePriceCents = item.final_price;
          var props = item.properties || {};
          
          var wiPrice = props['_wi_calculated_price']
            ? Math.round(parseFloat(props['_wi_calculated_price']) * 100)
            : 0;
          
          if (wiPrice > 0 && item.price > 0) {
            var ratio = item.final_price / item.price;
            wiPrice = Math.round(wiPrice * ratio);
          }
          
          var hulkTotal = 0;
          Object.keys(props).forEach(function(key) {
            if (key.startsWith('_')) return;
            hulkTotal += extractPriceFromText(String(props[key]));
          });
          
          var hasCustomPrice = wiPrice > 0 || hulkTotal > 0;
          var itemTotal = hasCustomPrice
            ? (wiPrice > 0 ? wiPrice + hulkTotal : basePriceCents + hulkTotal)
            : basePriceCents;
          
          grandTotal += itemTotal * item.quantity;
          
          updateItemDOM(item, itemTotal);
        });
        
        updateSubtotal(grandTotal);
      })
      .catch(function(e) { console.warn('[CartFix] error:', e); })
      .finally(function() {
        setTimeout(function() {
          isUpdating = false;
          if (pendingUpdate) {
            pendingUpdate = false;
            debouncedUpdate();
          }
        }, 150);
      });
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = cart.item_count;
      el.classList.toggle('t4s-op-0', cart.item_count < 1);
    });

    if (document.body) {
      document.body.className = document.body.className.replace(/\bt4s-cart-count-\d+\b/g, '').trim();
      document.body.classList.add('t4s-cart-count-' + cart.item_count);
    }
  }
  
  function updateItemDOM(item, itemTotal) {
    var formatted = formatMoney(itemTotal);
    var formattedLine = formatMoney(itemTotal * item.quantity);

    function setPriceText(el, value) {
      if (!el) return;
      if (el.textContent.trim() !== value) {
        el.textContent = value;
      }
      el.classList.remove('is-hulk-price-pending');
      el.setAttribute('data-hulk-fixed-price', value);
    }
    
    var miniItems = [];
    var keyedPrice = document.querySelector('#t4s-mini_cart .t4s-cart_price[data-key="' + item.key + '"]');
    var keyedItem = keyedPrice ? keyedPrice.closest('[data-hulkapps-lineitem], [data-cart-item], .t4s-mini_cart__item') : null;

    if (keyedItem) {
      miniItems.push(keyedItem);
    } else {
      var rootKeyedItem = document.querySelector('#t4s-mini_cart [data-cart-key="' + item.key + '"]');
      if (rootKeyedItem) miniItems.push(rootKeyedItem);
    }

    if (!miniItems.length) {
      var pidItems = document.querySelectorAll('#t4s-mini_cart .t4s-mini_cart__item[data-pid="' + item.product_id + '"], #t4s-mini_cart [data-pid="' + item.product_id + '"][data-hulkapps-lineitem]');
      if (pidItems.length === 1) miniItems.push(pidItems[0]);
    }
    
    miniItems.forEach(function(itemEl) {
      // t4s-cart_price (текущая sale цена)
      var priceEl = itemEl.querySelector('.t4s-cart_price[data-key="' + item.key + '"], .t4s-cart_price');
      if (priceEl) {
        var ins = priceEl.querySelector('ins');
        if (ins) {
          setPriceText(ins, formattedLine);
        } else {
          // Если нет sale (нет del/ins) — просто заменяем текст, сохраняя структуру
          var moneySpan = priceEl.querySelector('.money');
          if (moneySpan) setPriceText(moneySpan, formattedLine);
          else setPriceText(priceEl, formattedLine);
        }
        priceEl.setAttribute('data-hulk-fixed-price', formattedLine);
      }
      
      // t4s-cart_meta_price (содержит и compare-at, и текущую)
      // Заменяем только последнюю цену (текущую), оставляя зачёркнутую
      var metaEl = itemEl.querySelector('.t4s-cart_meta_price');
      if (metaEl && !priceEl) {
        var insMeta = metaEl.querySelector('ins, .t4s-cart_price');
        if (insMeta) {
          setPriceText(insMeta, formattedLine);
        }
      }
    });
    
    // 2. Cart page items
    var pageItems = document.querySelectorAll('.t4s-page_cart__item[data-cart-key="' + item.key + '"]');
    if (!pageItems.length) {
      var pagePidItems = document.querySelectorAll(
        '.t4s-page_cart__item[data-pid="' + item.product_id + '"], ' +
        '.t4s-row__item-cart[data-pid="' + item.product_id + '"]'
      );
      pageItems = pagePidItems.length === 1 ? pagePidItems : [];
    }
    pageItems.forEach(function(itemEl) {
      var priceEl = itemEl.querySelector('.t4s-cart_meta_prices .t4s-cart_price, .t4s-cart_price');
      if (priceEl) priceEl.textContent = formatted;
      var totalEl = itemEl.querySelector('.t4s-cart-item-price, .t4s-cart-item-total, .t4s-cart-item-line-price');
      if (totalEl) totalEl.textContent = formatMoney(itemTotal * item.quantity);
    });
  }
  
  function updateSubtotal(grandTotalCents) {
    var formatted = formatMoney(grandTotalCents);

    function setTextIfChanged(el, value) {
      if (!el) return;
      if (el.textContent.trim() !== value) {
        el.textContent = value;
      }
      el.classList.remove('is-hulk-price-pending');
      el.setAttribute('data-hulk-fixed-price', value);
    }
    
    // Mini cart subtotal (Kalles: .t4s-cart__totalPrice)
    var miniSubtotals = document.querySelectorAll(
      '#t4s-mini_cart [data-er-cart-total-price], ' +
      '#t4s-mini_cart .t4s-cart__totalPrice, ' +
      '#t4s-mini_cart [data-cart-subtotal], ' +
      '#t4s-mini_cart [data-cart-prices] .money'
    );
    miniSubtotals.forEach(function(el) {
      // Сохраняем " USD" суффикс если он есть
      var hasUSD = el.textContent.indexOf('USD') !== -1;
      setTextIfChanged(el, formatted + (hasUSD ? ' USD' : ''));
    });
    
    // Cart page subtotal
    var pageSubtotals = document.querySelectorAll(
      '.t4s-cart__subtotal-price, ' +
      '.t4s-cart-subtotal__price, ' +
      '[data-cart-page-subtotal], ' +
      '.t4s-main-cart .t4s-cart__totalPrice, ' +
      '.t4s-main-cart [data-er-cart-total-price]'
    );
    pageSubtotals.forEach(function(el) {
      setTextIfChanged(el, formatted);
    });
  }
  
  function debouncedUpdate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateCartPrices, 250);
  }

  function markUntrustedCartPrices() {
    document.querySelectorAll('#t4s-mini_cart .t4s-cart_price, .t4s-main-cart .t4s-cart_price').forEach(function(priceEl) {
      priceEl.classList.remove('is-hulk-price-pending');
    });
  }

  function scheduleCartPriceRefresh() {
    markUntrustedCartPrices();
    debouncedUpdate();
    setTimeout(debouncedUpdate, 350);
    setTimeout(debouncedUpdate, 900);
    setTimeout(debouncedUpdate, 1800);
  }
  
  function init() {
    var path = window.location.pathname;
    var isCartPage = path === '/cart' || path.indexOf('/cart') === 0;
    
    if (isCartPage) {
      debouncedUpdate();
      var cartContainer = document.querySelector('.t4s-page-cart, [data-cart-container], main');
      if (cartContainer) {
        var observer = new MutationObserver(function(mutations) {
          var meaningful = mutations.some(function(m) {
            return m.type === 'childList' && m.addedNodes.length > 0;
          });
          if (meaningful) scheduleCartPriceRefresh();
        });
        observer.observe(cartContainer, { childList: true, subtree: true });
      }
    }
    
    // Mini cart — обновляем при открытии drawer
    document.addEventListener('click', function(e) {
      var target = e.target.closest('[data-cart-icon], [data-drawer-open], .t4s-cart-icon, .t4s-action-cart, [href="/cart"], [href$="/cart"]');
      if (target) {
        // Drawer открывается с задержкой — даём ему отрендериться
        scheduleCartPriceRefresh();
      }
    });
    
    // Стандартные cart events
    ['cart:refresh', 'cart:updated', 'cart:change', 'cart.requestComplete'].forEach(function(evt) {
      document.addEventListener(evt, scheduleCartPriceRefresh);
    });
    
    // Если drawer уже открыт при загрузке — обновляем
    var drawer = document.getElementById('t4s-mini_cart');
    if (drawer && !drawer.hasAttribute('hidden')) {
      scheduleCartPriceRefresh();
    }

    if (drawer) {
      var drawerObserver = new MutationObserver(function(mutations) {
        var meaningful = mutations.some(function(mutation) {
          return mutation.type === 'childList' || mutation.type === 'characterData';
        });
        if (meaningful) scheduleCartPriceRefresh();
      });
      drawerObserver.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
